<script>
import LiveReportService from '@/services/ReportModules/LiveReportService'
import SalesByHourChart from '@/components/SalesByHourChart'
import LaborByHourChart from '@/components/LaborByHourChart'

export default {
  components: {
    SalesByHourChart,
    LaborByHourChart
  },
  props: {
    location: {
      type: Object,
      default () {
        return {}
      }
    },
    comparison: null,
    locations: {
      type: Array
    }
  },
  data: function () {
    return {
      locationSummary: {},
      loading: false,
      info: {
        labor: {}
      },
      trends: {
        salesByHour: {},
        laborByHour: {}
      },
      expanded: true
    }
  },
  computed: {
    noSummary: function () {
      return Array.isArray(this.locationSummary) && (this.locationSummary.length === 0)
    }
  },
  methods: {
    getLocationSummary () {
      this.loading = true
      LiveReportService.getLocationSummary(this.location.id)
        .then(data => {
          this.loading = false
          this.info = data
          // get historic data
          LiveReportService.locationHistoricData(this.location)
            .then(data => {
              this.trends = data
            })
        })
    },
    trendDirection: function (num) {
      if (parseFloat(num) >= 0) {
        return 'fas fa-arrow-up'
      } else {
        return 'fas fa-arrow-down'
      }
    },
    trendColor: function (num, reverse) {
      reverse = reverse === true
      if (parseFloat(num) >= 0 || (parseFloat(num) < 0 && reverse === true)) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
    calculatePercentDifference: function (one, two) {
      var x = parseFloat(one)
      var y = parseFloat(two)
      var diff = Number(0)
      diff = (x / y - 1) * 100
      return diff.toFixed(2)
    }
  },
  mounted: function () {
    this.getLocationSummary()
  }
}
</script>

<template>
  <div class="row">
    <div
      class="col-sm-12 card-size"
      v-bind:class="{ 'no-data': info && !info.sales }"
    >
      <div class="card h-100">
        <div
          class="card-header"
          v-bind:class="{ 'list-group-item active' : info && info.sales }"
        >
          <span
            class="float-right"
            v-if="info && info.sales"
          >
            &nbsp;
            <a
              href="#"
              v-on:click.prevent="expanded = !expanded"
            >
              <span
                class="fas fa-plus-square"
                v-show="!expanded"
              ></span>
              <span
                class="fas fa-minus-square"
                v-show="expanded"
              ></span>
            </a>
          </span>
          <span
            v-if="info && info.lastupdate"
            class="float-right"
          >{{ info.lastupdate | moment('LT') }}</span>
          {{ location.name }}
          <span v-if="info && !info.sales">
            <div
              class="float-right"
              v-if="loading"
            >
              <div class="ng-loader">
                <i class="fa-2x fas fa-spinner fa-pulse"></i>
              </div>
            </div>
          </span>
          <span v-if="info && !info.sales && !loading">- No live data available.</span>
        </div>
        <div
          class="list-group-item"
          v-if="info && info.sales && expanded"
        >
          <div class="row">
            <!-- sales/labor details -->
            <div class="col-sm-12 col-lg-6">
              <div
                class="list-group-item"
                v-if="info.sales"
              >
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Net Sales:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.sales.net | formatNumber('$0,0.00') }}</strong>
                      </div>
                    </div>
                    <!-- <div class="pull-right"
                  :class="trendColor(calculatePercentDifference(info.sales.net, trends[location.id][comparison].net))"
                  v-if="info.sales.net && trends[location.id] && trends[location.id][comparison].net && trends[location.id][comparison].net != info.sales.net">
                  {{calculatePercentDifference(info.sales.net, trends[location.id][comparison].net) | formatNumber('0')}}%
                  <span
                    :class="trendDirection(calculatePercentDifference(info.sales.net, trends[location.id][comparison].net))"></span>
                    </div>-->
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Guests:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.sales.guestcount | formatNumber('0,00') }}</strong>
                      </div>
                    </div>
                    <!-- <div class="pull-right"
                  :class="trendColor(calculatePercentDifference(info.sales.guestcount, trends[location.id][comparison].guestcount))"
                  v-if="info.sales.guestcount && trends[location.id] && trends[location.id][comparison].guestcount && trends[location.id][comparison].guestcount != info.sales.guestcount">
                  {{calculatePercentDifference(info.sales.guestcount, trends[location.id][comparison].guestcount) | formatNumber('0,0')}}%
                  <span
                    :class="trendDirection(calculatePercentDifference(info.sales.guestcount, trends[location.id][comparison].guestcount))"></span>
                    </div>-->
                  </div>
                </div>
              </div>
              <div
                class="list-group-item"
                v-if="info.labor"
              >
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Labor:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.labor.laborcost | formatNumber('$0,0.00') }}</strong>
                      </div>
                    </div>
                    <!-- <div class="pull-right"
                  :class="trendColor(calculatePercentDifference(info.labor.laborcost, trends[location.id][comparison].labor), true)"
                  v-if="info.labor.laborcost && trends[location.id] && trends[location.id][comparison].labor && trends[location.id][comparison].labor != info.labor.laborcost">
                  {{calculatePercentDifference(info.labor.laborcost, trends[location.id][comparison].labor) | formatNumber('0,00')}}%
                  <span
                    :class="trendDirection(calculatePercentDifference(info.labor.laborcost, trends[location.id][comparison].labor))"></span>
                    </div>-->
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Hours:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.labor.hours | formatNumber('0,0.00')}}</strong>
                      </div>
                    </div>
                    <!-- <div class="pull-right"
                  :class="trendColor(calculatePercentDifference(info.labor.hours, trends[location.id][comparison].hours), true)"
                  v-if="info.labor.hours && trends[location.id] && trends[location.id][comparison].hours && trends[location.id][comparison].hours != info.labor.hours">
                  {{calculatePercentDifference(info.labor.hours, trends[location.id][comparison].hours) | formatNumber('0,00')}}%
                  <span
                    :class="trendDirection(calculatePercentDifference(info.labor.hours, trends[location.id][comparison].hours))"></span>
                    </div>-->
                  </div>
                </div>
              </div>
              <div
                class="list-group-item"
                v-show="!info.labor"
              >
                <div class="row">
                  <div class="col-12 text-center">
                    <em>No labor data available</em>
                  </div>
                </div>
              </div>
              <div
                class="list-group-item"
                v-if="info.lasthour"
              >
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Last Hour:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.lasthour.lasthour_sales | formatNumber('$0,0.00') }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="row">
                      <div class="col-6">Tickets:</div>
                      <div class="col-6 text-right">
                        <strong>{{ info.lasthour.lasthour_checks | formatNumber('0,00')}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="list-group-item"
                v-show="!info.lasthour"
              >
                <div class="row">
                  <div class="col-12 text-center">
                    <em>No data for last hour</em>
                  </div>
                </div>
              </div>
              <div class="list-group-item">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div v-if="info.sales">
                      <div class="row">
                        <div class="col-8">Current Guests:</div>
                        <div class="col-4 text-right">
                          <strong>{{ info.sales.guestcurrent | formatNumber('0,00') }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div v-if="info.labor && info.labor.clocked_in">
                      <div class="row">
                        <div class="col-8">Current Employees:</div>
                        <div class="col-4 text-right">
                          <strong>{{ info.labor.clocked_in }}</strong>
                          <div
                            class="float-right"
                            :class="trendColor(info.needed, true)"
                            v-if="info.needed != 0"
                          >
                            ({{ info.needed | formatNumber('0,0') }}
                            <span :class="trendDirection(info.needed)"></span>)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-6">
              <div class="chart-wrapper">
                <div class="row">
                  <div class="col-7 text-right">
                    <router-link :to="'/live/location/' + location.id + '/sales'">
                      <strong>
                        <u>Sales Per Hour</u>
                      </strong>
                    </router-link>
                  </div>
                  <div class="col-5">
                    <router-link :to="'/live/location/' + location.id + '/sales'">
                      <u>Details</u>&nbsp;
                      <span class="oi oi-chevron-right"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </router-link>
                  </div>
                </div>
                <SalesByHourChart
                  v-if="info.salesByHour"
                  :comparison="comparison"
                  :hours="info.hours"
                  :historic="trends.salesByHour"
                  :salesByHour="info.salesByHour"
                ></SalesByHourChart>
              </div>
              <div class="chart-wrapper">
                <div class="row">
                  <div class="col-7 text-right">
                    <router-link :to="'/live/location/' + location.id + '/labor'">
                      <strong>
                        <u>Labor % Per Hour</u>
                      </strong>
                    </router-link>
                  </div>
                  <div class="col-5">
                    <router-link :to="'/live/location/' + location.id + '/labor'">
                      <u>Details</u>&nbsp;
                      <span class="oi oi-chevron-right"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                    </router-link>
                  </div>
                </div>
                <LaborByHourChart
                  v-if="info.laborByHour"
                  :comparison="comparison"
                  :hours="info.hours"
                  :historic="trends.laborByHour"
                  :laborByHour="info.laborByHour"
                ></LaborByHourChart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.loader-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-size {
  margin-bottom: 10px;
}
img.summary-loading {
  height: 3em;
}
@media all and (max-width: 990px) {
  .chart-wrapper {
    margin-top: 1em;
  }
}
.list-group-item.active a {
  color: #fff;
}
</style>
